import { functionStrings } from './helpers';
export const camelToStartCase = (camelCaseString) => camelCaseString
    // insert a space between lower & upper
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    // space before last upper in a sequence followed by lower
    .replace(/\b([A-Z]+)([A-Z])([a-z])/, '$1 $2$3')
    // uppercase the first letter
    .replace(/([a-zA-Z])/, (str) => str.toUpperCase());
export const toKebabCase = (str) => str
    .replace(/([A-Z])([A-Z][a-z])/g, '$1-$2')
    .replace(/([a-z])([A-Z])/g, '$1-$2')
    .replace(/[\s_]+/g, '-')
    .toLowerCase();
export const stringifyWithDefaults = (obj) => {
    // Stringify non-function values normally. Add a template block for functions to be replaced later
    let res = JSON.stringify(obj, (key, value) => (value instanceof Function ? `${key}_CODE` : value), '  ');
    // Replace template blocks with function strings
    Array.from(res.matchAll(/"(\w*)_CODE"/g)).forEach((match) => {
        const [codePlaceholder, key] = match;
        const functionString = functionStrings[key];
        if (functionString) {
            res = res.replaceAll(codePlaceholder, functionString);
        }
        else {
            console.error(`Function string for ${key} not found.`); // eslint-disable-line
        }
    });
    return res;
};
